<template>
  <LayoutSearchPanel v-if="isMenuOpen" />
</template>

<script setup lang="ts">
  const searchMenuStore = useSearchMenuStore();
  const { isMenuOpen } = storeToRefs(searchMenuStore);
</script>
